import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navItems = ['How It Works', 'Pricing'];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 px-4 md:px-8 py-4 transition-all duration-300 z-50 ${
        isScrolled
          ? 'bg-white/80 backdrop-blur-lg border-b border-neutral-200 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <Link
          to="hero"
          className="inline-flex items-center space-x-2 cursor-pointer hover:opacity-70 transition duration-150"
          smooth={true}
          duration={300}
        >
          <img src="/icon.png" alt="Turret" className="w-8 h-8 object-contain" />
          <span className="text-xl font-bold text-neutral-900">Turret</span>
        </Link>

        <div className="md:hidden">
          <button
            className="text-neutral-700 focus:outline-none p-2"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {menuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              )}
            </svg>
          </button>
        </div>

        <ul className="hidden md:flex items-center space-x-8">
          {navItems.map((item) => (
            <li key={item}>
              <Link
                className="text-neutral-600 hover:text-neutral-900 cursor-pointer transition-colors duration-200"
                to={item.toLowerCase().replace(/\s+/g, '-')}
                spy={true}
                smooth={true}
                offset={-80}
                duration={300}
              >
                {item}
              </Link>
            </li>
          ))}
        </ul>

        <a
          href="https://dashboard.useturret.com"
          className="hidden md:inline-flex px-5 py-2.5 bg-turret-purple text-white text-sm font-semibold rounded-lg hover:bg-turret-purple-light transition duration-200"
        >
          Get Started
        </a>
      </div>

      {menuOpen && (
        <div className="md:hidden mt-4 pb-4 border-t border-neutral-200 pt-4 bg-white">
          <div className="flex flex-col space-y-4">
            {navItems.map((item) => (
              <Link
                key={item}
                className="text-neutral-600 hover:text-neutral-900 px-2 py-2 transition-colors duration-200"
                to={item.toLowerCase().replace(/\s+/g, '-')}
                spy={true}
                smooth={true}
                offset={-80}
                duration={300}
                onClick={() => setMenuOpen(false)}
              >
                {item}
              </Link>
            ))}
            <a
              href="https://dashboard.useturret.com"
              className="px-5 py-3 bg-turret-purple text-white text-sm font-semibold rounded-lg text-center hover:bg-turret-purple-light transition duration-200"
            >
              Get Started
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};
